import { render, staticRenderFns } from "./BasicTable.vue?vue&type=template&id=399f0977&scoped=true&"
import script from "./BasicTable.vue?vue&type=script&lang=ts&"
export * from "./BasicTable.vue?vue&type=script&lang=ts&"
import style0 from "./BasicTable.vue?vue&type=style&index=0&id=399f0977&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399f0977",
  null
  
)

export default component.exports